/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type { ApiResult, DeviceGroupDto } from "../models/index";
import {
    ApiResultFromJSON,
    ApiResultToJSON,
    DeviceGroupDtoFromJSON,
    DeviceGroupDtoToJSON,
} from "../models/index";

export interface FaultedSitesRequest {
    organisationId?: string;
}

export interface FaultedSitesCountRequest {
    deviceGroupTags?: Array<string>;
}

/**
 *
 */
export class FaultsHttpFunctionsApi extends runtime.BaseAPI {
    /**
     * Get a list of faulted sites. Will return a global list if no organisation ID is provided.
     */
    async faultedSitesRaw(
        requestParameters: FaultedSitesRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<DeviceGroupDto>>> {
        const queryParameters: any = {};

        if (requestParameters["organisationId"] != null) {
            queryParameters["organisationId"] =
                requestParameters["organisationId"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/faults/faulted-sites`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(DeviceGroupDtoFromJSON),
        );
    }

    /**
     * Get a list of faulted sites. Will return a global list if no organisation ID is provided.
     */
    async faultedSites(
        requestParameters: FaultedSitesRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<DeviceGroupDto>> {
        const response = await this.faultedSitesRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Get a count of faulted sites. Will return a global list if no organisation ID is provided.
     */
    async faultedSitesCountRaw(
        requestParameters: FaultedSitesCountRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        const queryParameters: any = {};

        if (requestParameters["deviceGroupTags"] != null) {
            queryParameters["deviceGroupTags"] = requestParameters[
                "deviceGroupTags"
            ]!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/faults/faulted-sites-count`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Get a count of faulted sites. Will return a global list if no organisation ID is provided.
     */
    async faultedSitesCount(
        requestParameters: FaultedSitesCountRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.faultedSitesCountRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }
}
